export interface IObservationDescriptionResponseError{
	field:string;
	message:string;
}

export class ObservationDescriptionResponse {
	errors:IObservationDescriptionResponseError[] = [];

	public constructor(data:any){
		this.errors = data.errors || [];
	}

}